/**
 * @desc 列表 树结构
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmCategoryTreeResponseDto>>;
export function request(
  body: defs.basics.PlmCategoryRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/category/list/tree`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
